import moment from 'moment';

export function formatTimestamp(unix: number) {
  return moment.unix(unix).utc().format('DD MMMM yyyy');
  // return moment.unix(unix).local().format('YYYY-MM-DD HH:mm');
}
export function timeAgo(unix: number) {
  return moment.unix(unix).local().fromNow();
}
